import React from 'react'
import BalanceManagerPage from "./BalanceManagerPage"
import InformationUserContainer from "../../InformationUserContainer"

function BalanceManagerContainer() {
    return (
        <div className="BalanceManagerContainer">
            <InformationUserContainer isActive="balance">
                <BalanceManagerPage/>
            </InformationUserContainer>
        </div>
    )
}

export default BalanceManagerContainer
